import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import TextField from '@material-ui/core/TextField';

export const SearchSite = () => {
    const [isShown, setIsShown] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const initialValues = {
        query: "",
    };
    const searchSchema = Yup.object().shape({ query: Yup.string() });
    useEffect(() => {
        if (!location.pathname.includes('/search'))
            setIsShown(true);
        else
            setIsShown(false);
    }, [setIsShown, location.pathname]);

    return (<>
        {isShown && <div className="martin-search">
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={searchSchema}
                onSubmit={(values) => {
                    navigate('/search/' + encodeURIComponent(values.query));
                }}>
                {({ values, errors, touched, handleChange, handleSubmit, handleReset, setFieldValue, getFieldProps }) => {
                    return (
                        <React.Fragment>
                            <TextField
                                color="secondary"
                                autoComplete="off"
                                name="query"
                                value={values.query}
                                onChange={handleChange}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') handleSubmit();
                                }}
                                margin="dense"
                                id="query"
                                type="query"
                                error={Boolean(errors.query && touched.query)}
                                placeholder="Search..."
                                fullWidth
                            />
                        </React.Fragment>
                    );
                }}
            </Formik>
        </div>}
    </>);
}